"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateKnowledgeFileDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class CreateKnowledgeFileDto {
}
exports.CreateKnowledgeFileDto = CreateKnowledgeFileDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CreateKnowledgeFileDto.prototype, "title", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)(),
    (0, class_transformer_1.Type)(() => Number) // Add this decorator
    ,
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateKnowledgeFileDto.prototype, "docTypeId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)(),
    (0, class_transformer_1.Type)(() => Number) // Add this decorator
    ,
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateKnowledgeFileDto.prototype, "categoryId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], CreateKnowledgeFileDto.prototype, "summary", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Object)
], CreateKnowledgeFileDto.prototype, "tags", void 0);
